import { Flex, Icon, SimpleGrid, Spacer, Stack, Text, Link, useColorModeValue as colorValue,useToast } from '@chakra-ui/react'
import { useEffect, useRef, useState } from 'react'
import { getDashboardStatistic } from '../../classes/DashboardStat'
import { BsClipboardData, BsFiles, BsBuilding } from "react-icons/bs";
import { Link as ReactLink } from 'react-router-dom'
import { useSelectedItemAlertContext } from '../../context/selectedItemAlertContext';
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const StatBlock = ({ count, bgColor, title, icon, link }) => {
    return (
        <Link flex={1} as={ReactLink} to={link} style={{ textDecoration: "none" }}>
            <Flex bgColor={bgColor} borderRadius={6} p={4} align="center" _hover={{ shadow: "lg" }} >
                <Flex direction="column">
                    <Text fontWeight="bold">{title}</Text>
                    <Text fontWeight="bold" fontSize="xxx-large">{count}</Text>
                </Flex>
                <Spacer />
                <Icon as={icon} w={16} h={16} />
            </Flex>
        </Link>
    )
}

const StatQueue = ({ q }) => {
    return (
        <Flex>
            <Text>{q.name} : <Text as="span" fontWeight="bold" color={colorValue("blue.700","white")}>{q.total_queue} คิว</Text></Text>
        </Flex>
    )
}
const StatTotalQueues = ({ data }) => {
    return (
        <ReactLink to="/queue">
            <Flex flex={2} bgColor={colorValue("green.200", "green.800")} borderRadius={6} p={4} align="center" _hover={{ shadow: "lg" }}>
                <Flex direction="column">
                    <Text fontWeight="bold">คิวรอเข้าพักอาคาร</Text>
                    <SimpleGrid columns={{ sm: 1, lg: 2 }} spacing={3} mt={3}>
                        {data?.map((queue, index) => (<StatQueue q={queue} key={`stat_queue_${index}`} />))}
                    </SimpleGrid>
                </Flex>
                <Spacer />
                <Icon as={BsBuilding} w={16} h={16} />
            </Flex>
        </ReactLink>
    )
}


const DashboardStatPanel = () => {
    const [statData, setStatData] = useState(null)
    const { itemData } = useSelectedItemAlertContext()
    const toast = useToast()
    const loadData = useRef()
    
    loadData.current = async () => {
        await getDashboardStatistic()
            .then(res => {
                // console.log(res)
                setStatData(res)
            })
            .catch(error => {
                // console.log(error)
                toast(toastVal({
                    title: "การดึงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    useEffect(() => {
        loadData.current()
    }, [itemData?.reload])

    return (
        <Stack spacing={3} direction={{ sm: "column", lg: "row" }}>
            <StatBlock count={statData?.newForms} bgColor={colorValue("orange.200", "orange.800")} title="คำร้องใหม่" icon={BsClipboardData} link="/newforms" />
            <StatBlock count={statData?.totalForms} bgColor={colorValue("blue.200", "blue.800")} title="คำร้องทั้งหมด" icon={BsFiles} link="/forms" />
            <StatTotalQueues data={statData?.totalQueue} />
        </Stack>
    )
}

export default DashboardStatPanel
